import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Download, LockKeyhole, Plane } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function TicketPage() {
  const { code } = useParams();
  const [ticket, setTicket] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/registrations/${code}/boarding-pass`)
      .then(({ data }) => setTicket(data))
      .catch((requestError) => setError(formatApiError(requestError, "Boarding Pass konnte nicht geladen werden.")))
      .finally(() => setLoading(false));
  }, [code]);

  return (
    <main className="relative grid min-h-screen place-items-center overflow-hidden bg-[#09090D] px-5 py-12 text-white">
      <div className="hero-grid absolute inset-0 opacity-35" />
      <div className="relative w-full max-w-3xl">
        {loading && <div data-testid="ticket-loading-state" className="rounded-[2rem] border border-white/10 bg-[#13131A] p-10 text-center text-[#E5C378]">Boarding Pass wird geladen...</div>}
        {!loading && error && (
          <div data-testid="ticket-locked-state" className="rounded-[2rem] border border-amber-400/25 bg-[#13131A] p-10 text-center shadow-2xl shadow-black/50">
            <LockKeyhole className="mx-auto h-10 w-10 text-[#E5C378]" />
            <h1 className="mt-6 font-syne text-3xl font-bold">Ticket nicht verfügbar</h1>
            <p className="mx-auto mt-4 max-w-md text-zinc-400">{error}</p>
            <p className="mt-3 font-mono text-sm text-[#E5C378]">{code}</p>
            <Link data-testid="ticket-home-link" to="/" className="mt-8 inline-flex rounded-full border border-[#E5C378]/30 px-6 py-3 text-sm font-bold text-[#E5C378] transition-colors duration-200 hover:bg-[#E5C378]/10">Zur Startseite</Link>
          </div>
        )}
        {!loading && ticket && (
          <section data-testid="ticket-boarding-pass" className="overflow-hidden rounded-[2rem] bg-[#F4F1E8] text-[#111116] shadow-2xl shadow-black/60">
            <div className="flex items-center justify-between gap-4 bg-[#111116] px-6 py-6 text-[#F4F1E8] sm:px-10">
              <div className="flex items-center gap-4"><Plane className="h-7 w-7 text-[#E5C378]" /><div><p className="font-mono text-xs tracking-[0.3em] text-[#E5C378]">VYORA AIR</p><h1 className="font-syne text-3xl font-extrabold">BOARDING PASS</h1></div></div>
              <div className="text-right"><p className="text-xs uppercase tracking-[0.2em] text-zinc-400">{ticket.event_name}</p><p className="font-bold text-[#E5C378]">{ticket.event_date}</p></div>
            </div>
            <div className="grid gap-8 p-6 sm:grid-cols-[1fr_230px] sm:p-10">
              <div>
                <p className="font-mono text-xs uppercase tracking-[0.22em] text-zinc-500">Passagier</p>
                <p data-testid="ticket-passenger-name" className="mt-2 font-syne text-3xl font-bold">{ticket.registration.full_name}</p>
                <p className="mt-8 font-mono text-xs uppercase tracking-[0.22em] text-zinc-500">Ticket-Code</p>
                <p data-testid="ticket-code" className="mt-2 break-all font-mono text-2xl font-bold text-[#9A6700]">{ticket.registration.registration_code}</p>
                <div className="mt-8 grid gap-3 text-sm font-bold sm:grid-cols-3">
                  <span className="rounded-2xl bg-[#E9E0CB] px-4 py-3">€{ticket.registration.price_eur} AM EINGANG</span>
                  <span className="rounded-2xl bg-[#E9E0CB] px-4 py-3">PILOT EVENT</span>
                  <span className="rounded-2xl bg-[#E9E0CB] px-4 py-3">HAUPTEINGANG</span>
                </div>
              </div>
              <div className="self-start rounded-[1.5rem] bg-[#E5C378] p-3">
                <img data-testid="ticket-qr-image" src={ticket.qr_code_data_url} alt="Vyora QR-Boarding-Pass" className="w-full rounded-xl" />
                <p className="py-3 text-center font-mono text-[10px] uppercase tracking-[0.18em]">Am Eingang scannen</p>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-4 border-t-2 border-dashed border-[#C9B98E] px-6 py-6 sm:px-10">
              <p className="text-sm text-zinc-600">Bitte am Eingang €{ticket.registration.price_eur} bezahlen und diesen QR-Code vorzeigen.</p>
              <a data-testid="ticket-download-button" href={ticket.download_url} className="inline-flex items-center gap-2 rounded-full bg-[#111116] px-6 py-3 text-sm font-bold text-[#E5C378] transition-transform duration-200 hover:-translate-y-0.5">
                <Download className="h-4 w-4" /> PNG herunterladen
              </a>
            </div>
          </section>
        )}
      </div>
    </main>
  );
}
